import { BookMakers, EventData, FancyMarkets, MatchOdds, TopicUrls } from "../../models/EventData";
import CATALOG_API from "../../services/sap_catalog";
import store from "../store";
import { updateTopicUrls, setEventInfoOnSuccess, setExchSports, setExchEvents, updateExchEvents, setSBSports, setSBEvents, updateSBEvents } from "./exchangeSportsReducer";
import { connectToWS, disconnectToWS } from "../../websockets/webSocket";
import { getGameUrl } from "../authActions";
import { toast } from "react-toastify";

export const getFancyMarkets = (eventInfo: EventData): any[] => {
  let fancyMarkets: FancyMarkets[] = [];

  if (eventInfo && eventInfo?.markets && eventInfo?.markets?.fancyMarkets) {
    fancyMarkets = eventInfo?.markets?.fancyMarkets;
  }

  return [...fancyMarkets].sort((a, b) => {
    const aSort = a?.sort ? Number(a.sort) : 0;
    const bSort = b?.sort ? Number(b.sort) : 0;
    if (aSort !== bSort) {
      return aSort - bSort;
    }
    const aDesc = a?.marketName;
    const bDesc = b?.marketName;
    return aDesc.localeCompare(bDesc);

  });
};

export const getAllMatchOddsData = (eventInfo: EventData): MatchOdds[] => {
  let markets: MatchOdds[] = [];
  if (eventInfo && eventInfo.markets && eventInfo.markets.matchOdds) {
    if (eventInfo.markets.matchOdds.length > 1) {
      markets = [...eventInfo.markets.matchOdds];
    } else {
      markets = eventInfo.markets.matchOdds;
    }
  }

  let data = markets?.filter((item) => item.marketType !== "LINE_ODDS");

  data?.sort((a, b) => {
    const aDesc =
      a.marketName === "Match Odds" ? "aaa" : a.marketName.toLowerCase();
    const bDesc =
      b.marketName === "Match Odds" ? "aaa" : b.marketName.toLowerCase();
    if (aDesc > bDesc) return 1;
    else if (aDesc < bDesc) return -1;
    return 0;
  });
  return data;
};

export const getBookMakerMarkets = (eventInfo: EventData) => {
  let bmMarkets: BookMakers[] = [];

  if (eventInfo && eventInfo?.markets?.bookmakers) {
    // return eventInfo?.markets?.matchOdds;
    if (eventInfo?.markets?.bookmakers.length > 1) {
      let bMarkets = eventInfo?.markets?.bookmakers.filter(
        (bm) =>
          !(
            bm?.marketName?.toLowerCase() === "toss" &&
            bm?.status?.toLowerCase() === "suspended"
          )
      );
      bmMarkets = [...bMarkets];
    } else {
      bmMarkets = eventInfo?.markets?.bookmakers.filter(
        (bm) =>
          !(
            bm?.marketName?.toLowerCase() === "toss" &&
            bm?.status?.toLowerCase() === "suspended"
          )
      );
    }
  }
  return bmMarkets;
};


  export const fetchEventInfo = (sportId: string, eventId: string, navigate: Function) => {
    return async (dispatch: Function, getState: Function) => {
      try {
        let exchData = getState().userDetails.exchData;
  
        if (!(exchData && exchData?.token)) {
          await dispatch(getGameUrl('EX123'));
  
          exchData = getState().userDetails.exchData;
  
          if (!(exchData && exchData?.token)) {
            console.error("Failed to retrieve exchData after getGameUrl");
            return;
          }
        }

        const result = await CATALOG_API.post(`/v2/core/list-markets`, {
          operatorId: exchData?.operatorId,
          sportId: sportId,
          eventId: eventId,
          token: exchData?.token,
          partnerId: exchData?.partnerId,
        });
  
        if (result?.data) {
          updateTopicUrlsInStore(dispatch, result.data.event);
          dispatch(setEventInfoOnSuccess(result.data.event));
        }
      } catch (err) {
        console.error("Error fetching event info:", err);
      }
    };
  };  

  export const fetchSREventInfo = (sportId: string, eventId: string, navigate:Function) => {
    
    return async (dispatch: Function, getState: Function) => {
      try {
        let sbData  = store.getState().userDetails.sbData;

        if (!(sbData && sbData?.token)) {
          await dispatch(getGameUrl('SB123'));

          sbData = getState().userDetails.exchData;

          if (!(sbData && sbData?.token)) {
            console.error("Failed to retrieve exchData after getGameUrl");
            return;
          }

        }
        let result = null;
        result = await CATALOG_API.post(`/v2/core/getmarkets`, {
          operatorId: sbData?.operatorId,
          sportId: sportId,
          eventId: eventId,
          token: sbData?.token,
          partnerId: sbData?.partnerId,
        });
  
        if (result && result?.data) {
          updateTopicUrlsInStore(dispatch, result.data.event);
          let event = result.data.event;
          if (event?.markets) {
            event.markets.premiumMarkets = event.markets.matchOdds;
            event.markets.matchOdds = [];
          }
          dispatch(setEventInfoOnSuccess(result.data.event));
        } 
      } catch (err) {
        console.log(err);
      }
    };
  };

const updateTopicUrlsInStore = (dispatch: Function, eventData: any) => {
  // Dispatch topic urls
  const topicUrlPayload: TopicUrls = {
    matchOddsBaseUrl: eventData?.markets?.matchOddsBaseUrl,
    matchOddsTopic: eventData?.markets?.matchOddsTopic,
    bookMakerBaseUrl: eventData?.markets?.bookMakerBaseUrl,
    bookMakerTopic: eventData?.markets?.bookMakerTopic,
    fancyBaseUrl: eventData?.markets?.fancyBaseUrl,
    fancyTopic: eventData?.markets?.fancyTopic,
    premiumBaseUrl: eventData?.markets?.premiumBaseUrl,
    premiumTopic: eventData?.markets?.premiumTopic,
    matchOddsProvider: eventData?.markets?.matchOddsProvider,
    bookMakerProvider: eventData?.markets?.bookMakerProvider,
    fancyProvider: eventData?.markets?.fancyProvider,
    premiumProvider: eventData?.markets?.premiumProvider,
  };
  let topicUrls = store.getState().exchangeSports.topicUrls;
  if (
    ((topicUrls.matchOddsProvider &&
      eventData?.markets?.matchOddsProvider &&
      topicUrls.matchOddsProvider !== eventData?.markets?.matchOddsProvider) ||
      (topicUrls.bookMakerProvider &&
        eventData?.markets?.bookMakerProvider &&
        topicUrls.bookMakerProvider !==
        eventData?.markets?.bookMakerProvider) ||
      (topicUrls.fancyProvider &&
        eventData?.markets?.fancyProvider &&
        topicUrls.fancyProvider !== eventData?.markets?.fancyProvider) ||
      (topicUrls.matchOddsBaseUrl &&
        eventData?.markets?.matchOddsBaseUrl &&
        topicUrls.matchOddsBaseUrl !== eventData?.markets?.matchOddsBaseUrl) ||
      (topicUrls.matchOddsTopic &&
        eventData?.markets?.matchOddsTopic &&
        topicUrls.matchOddsTopic !== eventData?.markets?.matchOddsTopic) ||
      (topicUrls.bookMakerProvider &&
        eventData?.markets?.bookMakerBaseUrl &&
        topicUrls.bookMakerBaseUrl !== eventData?.markets?.bookMakerBaseUrl) ||
      (topicUrls.bookMakerTopic &&
        eventData?.markets?.bookMakerTopic &&
        topicUrls.bookMakerTopic !== eventData?.markets?.bookMakerTopic) ||
      (topicUrls.fancyBaseUrl &&
        eventData?.markets?.fancyBaseUrl &&
        topicUrls.fancyBaseUrl !== eventData?.markets?.fancyBaseUrl) ||
      (topicUrls.fancyTopic &&
        eventData?.markets?.fancyTopic &&
        topicUrls.fancyTopic !== eventData?.markets?.fancyTopic))
  ) {
    const baseUrlsPayload = {
      matchOddsBaseUrl: eventData?.markets?.matchOddsBaseUrl,
      bookMakerAndFancyBaseUrl: eventData?.markets?.bookMakerBaseUrl,
      premiumBaseUrl: eventData?.markets?.premiumBaseUrl,
    };
    disconnectToWS();
    setTimeout(() => {
      connectToWS(baseUrlsPayload);
    }, 1000);
  }
  dispatch(updateTopicUrls(topicUrlPayload));
};

export const fetchSports = (provider: string) => {
  return async (dispatch: Function, getState: Function) => {
    try {
      let data = null;
      if (provider === 'EX123') {
        data = getState().userDetails.exchData;
        if (!(data && data?.token)) {
          await dispatch(getGameUrl(provider));
        }
        data = getState().userDetails.exchData;
      } else if (provider === 'SB123') {
        data = getState().userDetails.sbData;
        if (!(data && data?.token)) {
          await dispatch(getGameUrl(provider));
        }
        data = getState().userDetails.sbData;
      }

      const response = await CATALOG_API.post(`/v1/core/getsports`, {
        operatorId: data?.operatorId,
        providerId: data?.providerId,
        partnerId: data?.partnerId,
      });

      if (response.data.status !== "RS_OK") {
        toast.error(response.data.errorDescription);
      }

      if (provider === 'EX123') {
        dispatch(setExchSports(response.data?.sports));
      } else if (provider === 'SB123') {
        dispatch(setSBSports(response.data?.sports));
      }
    } catch (e) {
      console.error("API Error:", e);
      toast.error("Failed to get sports. Please try again.");
    }
  };
};

export const listExchEvents = (inplay: boolean, sportId: string) => {
  return async (dispatch: Function, getState: Function) => {
    try {
      let data = getState().userDetails.exchData;
      if (!(data && data?.token)) {
        await dispatch(getGameUrl("EX123"));
      }
      data = getState().userDetails.exchData;
      dispatch(setExchEvents({}));

      const response = await CATALOG_API.post(`/v2/core/list-events-catalogue`, {
        isInplay: inplay,
        operatorId: data?.operatorId,
        providerId: data?.providerId,
        partnerId: data?.partnerId,
        sportId: sportId,
        token: data?.token,
        pageNo: -1
      });

      if (response.data.status !== "RS_OK") {
        return;
      }

      if (inplay) {
        dispatch(updateExchEvents({ key: "LIVE", data: mapEventsById(response.data?.sports) }));
        if (Array.isArray(response.data?.sports) && response.data.sports.length > 0) {
          updateTopicUrlsInStore(dispatch, response.data.sports[0]);
        }
      } else {
        dispatch(updateExchEvents({ key: "UPCOMING", data: mapEventsById(response.data?.sports) }));
      }

    } catch (e) {
      console.error("API Error:", e);
    }
  };
};

export const listLiveExchEvents = () => {
  return async (dispatch: Function, getState: Function) => {
    try {
      let data = getState().userDetails.exchData;
      if (!(data && data?.token)) {
        await dispatch(getGameUrl("EX123"));
      }
      data = getState().userDetails.exchData;
      dispatch(setExchEvents({}));

      const response = await CATALOG_API.post(`/v2/core/list-exch-events`, {
        isInplay: true,
        operatorId: data?.operatorId,
        providerId: data?.providerId,
        partnerId: data?.partnerId,
        token: data?.token,
        pageNo: -1
      });

      if (response.data.status !== "RS_OK") {
        return;
      }

      const events = response.data?.events;

      if (events && typeof events === 'object') {
        const updatedEventsMap: Record<string, any> = {};
        let firstEventUpdated = false;
        Object.entries(events).forEach(([sportId, eventList]) => {
          if (!firstEventUpdated && Array.isArray(eventList) && eventList?.length > 0) {
            updateTopicUrlsInStore(dispatch, eventList[0]);
            firstEventUpdated = true;
          }
          updatedEventsMap[`LIVE-${sportId}`] = mapEventsById(eventList as any[]);
        });
        dispatch(setExchEvents(updatedEventsMap));
      }
    } catch (e) {
      console.error("API Error:", e);
    }
  };
};


const mapEventsById = (events: any[]): Record<string, any> => {
  const eventMap: Record<string, any> = {};

  events.forEach((event) => {
    if (event?.eventId) {
      eventMap[event.eventId] = event;
    }
  });

  return eventMap;
};

export const listSBEvents = (inplay: boolean, sportId: string, pageNo: number) => {
  return async (dispatch: Function, getState: Function) => {
    try {
      let data = getState().userDetails.sbData;
      if (!(data && data?.token)) {
        await dispatch(getGameUrl("SB123"));
      }
      data = getState().userDetails.sbData;

      const response = await CATALOG_API.post(`/v2/core/getevents`, {
        isInplay: inplay,
        operatorId: data?.operatorId,
        providerId: data?.providerId,
        partnerId: data?.partnerId,
        sportId: sportId,
        token: data?.token,
        pageNo: pageNo
      });

      if (response.data.status !== "RS_OK") {
        dispatch(setSBEvents({}));
        return;
      }

      if (inplay) {
        dispatch(updateSBEvents({ key: "LIVE", data: mapEventsById(response.data?.sports), totalCount: response.data?.eventsCount }));
        if (Array.isArray(response.data?.sports) && response.data.sports.length > 0) {
          updateTopicUrlsInStore(dispatch, response.data.sports[0]);
        }
      } else {
        dispatch(updateSBEvents({ key: "UPCOMING", data: mapEventsById(response.data?.sports), totalCount: response.data?.eventsCount }));
      }

    } catch (e) {
      console.error("API Error:", e);
    }
  };
};

export const listLiveSBEvents = () => {
  return async (dispatch: Function, getState: Function) => {
    try {
      let data = getState().userDetails.sbData;
      if (!(data && data?.token)) {
        await dispatch(getGameUrl("SB123"));
      }
      data = getState().userDetails.sbData;
      dispatch(setSBEvents({}));

      const response = await CATALOG_API.post(`/v2/core/list-sr-events`, {
        isInplay: true,
        operatorId: data?.operatorId,
        providerId: data?.providerId,
        partnerId: data?.partnerId,
        token: data?.token,
        pageNo: -1
      });

      if (response.data.status !== "RS_OK") {
        return;
      }

      const events = response.data?.events;

      if (events && typeof events === 'object') {
        const updatedEventsMap: Record<string, any> = {};
        let firstEventUpdated = false;
        Object.entries(events).forEach(([sportId, eventList]) => {
          if (!firstEventUpdated && Array.isArray(eventList) && eventList?.length > 0) {
            updateTopicUrlsInStore(dispatch, eventList[0]);
            firstEventUpdated = true;
          }
          updatedEventsMap[`LIVE-${sportId}`] = mapEventsById(eventList as any[]);
        });
        dispatch(setSBEvents(updatedEventsMap));
      }
    } catch (e) {
      console.error("API Error:", e);
    }
  };
};